import React, {FunctionComponent, useCallback, useContext, useEffect, useRef, useState} from 'react';
import MapContext from '../map/MapContext';
import {useAppSelector, useAppDispatch} from '../../../redux/hooks';
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {classNames} from 'primereact/utils';
import {Trans, useTranslation} from 'react-i18next';
import {InputMask} from 'primereact/inputmask';
import {Controller, useForm} from 'react-hook-form';
import {InputText} from 'primereact/inputtext';
import {InputSwitch} from 'primereact/inputswitch';
import settings from '../../../config/settings';
import geoSettings from '../../../config/geoSettings';

type controlProps = {
    projectId: any
}
const PermalinkControl: FunctionComponent<controlProps> = (props) => {
    // @ts-ignore
    const {map} = useContext(MapContext);
    const checkedTrees = useAppSelector((state:any) => state.configLayer.layerData.layerTreeChecked);
    const keycloakToken = useAppSelector((state:any) => state.keycloakData.keycloak.keycloakToken);
    const checkedTreesRef = useRef(checkedTrees);
    const [visible, setVisible] = useState(false);
    const {t} = useTranslation(['geomonitoring']);
    const [formVisible, setFormVisible] = useState(true);
    const [permaLinkId, setPermaLinkId] = useState('');
    const [copyBttn, setCopyBttn] = useState(false);
    const copyBttnRef=useRef(copyBttn);

    const createBaseMapButton = () => {
        const buttonBookmarkMap = document.createElement('button');
        buttonBookmarkMap.id = 'buttonPermalink';
        buttonBookmarkMap.title = 'Permalink';
        buttonBookmarkMap.innerHTML = '<span style="color: black"><i class="fas fa-link"/></span>';
        buttonBookmarkMap.addEventListener('click', openDialog, false);
        return buttonBookmarkMap;
    };


    const openDialog = () => {
        setFormVisible(true);
        setVisible(true);
    };

    const defaultValues = {
        permalinkName: '',
        isPermaLink: false
    };

    const {
        control,
        formState: {errors},
        handleSubmit,
        getValues,
        reset
    } = useForm({defaultValues});

    const onSubmit = (data: any) => {
        sortData(data);
        reset();
    };

    const sortData = async (data: { isPermaLink: any; permalinkName: any; }) => {
        const layerArray = map.getLayers().getArray();
        const centerMap = map.getView().getCenter();
        const zoomLevel = map.getView().getZoom();
        const visibleLayerArray: { id: any; visible: any; }[] = [];
        layerArray.forEach(function (layer: { get: (arg0: string) => any; }) {
            if (layer.get('visible') === true || layer.get('visible') === 'true') {
                visibleLayerArray.push(layer.get('id'));
            }
        });

        const objToSave = {
            project_id: props.projectId,
            link: JSON.stringify({name: data.permalinkName, visibleLayerIds: visibleLayerArray}),
            position_x: centerMap[0],
            position_y: centerMap[1],
            zoom: Math.round(zoomLevel),
            is_permalink: data.isPermaLink,
            epsg_code: 3857
        };

        savePermaLink(objToSave).then((res: any) => {
            if (res.success == true) {

                if (data.isPermaLink) {
                    setCopyBttn(true);
                }
                const url = geoSettings.redirectUrlPermalink +'project/'+ props.projectId + '/' + res.data.id + '/#geomap';
                setPermaLinkId(url);
                setFormVisible(false);

            }

        });

    };

    const copyUrl = () => {
        navigator.clipboard.writeText(permaLinkId);
    };

    const savePermaLink = (data: any) => {
        const url = settings.apiUrl + '/createSpatialBookmarks';
        const requestOptions = {
            method: 'POST',
            headers: {
                authorization: 'Bearer ' + keycloakToken,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        };


        return new Promise((resolve, reject) => {
            fetch(url, requestOptions)
                .then(res => res.json())
                .then(
                    (result) => {
                        resolve({
                            success: true,
                            data: result
                        });
                    },
                    (error) => {
                        reject({
                            success: false,
                            info: 'GET failed: ' + error
                        });
                    });
        });
    };

    const addControl = () => {

        const permalinkElem = document.getElementById('buttonPermalink');
        if (permalinkElem === null) {
            const buttonBookmarkMap = createBaseMapButton();
            const elementLegende = document.getElementById('olToolkitControls');
            elementLegende?.appendChild(buttonBookmarkMap);
        }
        return [permalinkElem];
    };

    const getFormErrorMessage = (name: string) => {
        // @ts-ignore
        return errors[name] ? <small className="p-error">{errors[name].message}</small> :
            <small className="p-error">&nbsp;</small>;
    };


    useEffect(() => {
        checkedTreesRef.current = checkedTrees;
    }, [checkedTrees]);

    useEffect(() => {
        copyBttnRef.current = copyBttn;
    }, [copyBttn]);

    useEffect(() => {
        if (!map || Object.keys(map).length === 0) return;
        const permaControl = addControl();
        return () => map.controls.remove(permaControl);
    }, [map]);


    return (
        <Dialog header={formVisible ? t('permalinkHeader') : t('permalinkSuccess')} visible={visible}
            style={{width: '20vw'}}
            onHide={() => setVisible(false)}>
            {formVisible &&
                <form onSubmit={handleSubmit(onSubmit)} className="flex flex-column gap-2">
                    <Controller
                        name="permalinkName"
                        control={control}
                        rules={{required: t('permalinkNameError')}}
                        render={({field, fieldState}) => (
                            <>
                                <label htmlFor={field.name}
                                    className={classNames({'p-error': errors.permalinkName})}></label>
                                <span className="p-float-label">
                                    <InputText id={field.name} value={field.value}
                                        className={classNames({'p-invalid': fieldState.error})}
                                        onChange={(e) => field.onChange(e.target.value)}/>
                                    <label htmlFor={field.name}>{t('permalinkName')}</label>
                                </span>
                                {getFormErrorMessage(field.name)}
                            </>
                        )}
                    />
                    <Controller
                        name="isPermaLink"
                        control={control}
                        render={({field, fieldState}) => (
                            <>
                                <InputSwitch inputId={field.name} checked={field.value} inputRef={field.ref}
                                    className={classNames({'p-invalid': false})}
                                    onChange={(e) => field.onChange(e.value)}/>
                                <label htmlFor={field.name}>{t('permalinkBool')}</label>
                            </>
                        )}
                    />
                    <Button label={t('permalinkSave')} type="submit" icon="pi pi-check"/>
                </form>}
            {(!formVisible&&copyBttnRef.current) &&
                <div><Trans
                    i18nKey="permalinkSuccessMessage">Ihre Ansicht können Sie unter <a
                        href={permaLinkId}>{permaLinkId}</a> aufrufen</Trans> <Button icon={'fa fa-copy'} className="btn clipboard p-button-sm" onClick={copyUrl} title={ t('permalinkCopyTooltip') }></Button>
                </div>}
            {(!formVisible&&!copyBttnRef.current) &&
                <div>{t('bookmarkMessage')}</div>}
        </Dialog>);
};

export default PermalinkControl;
